export default {
    apiFileUploader(data, urldata = mixins.params()) {
        console.log("filedata", data);
        return this.request(this.api().fileuploader, data)
            .urltransform(urldata)
            .multipart()
            .exec()
            .log()
            .get();
    },
    apiFileUploaderPublic(data, urldata = mixins.params()) {
        console.log("filedata", data);
        return this.request(this.api().fileuploaderpublic, data)
            .urltransform(urldata)
            .multipart()
            .exec()
            .log()
            .get();
    },
    apiFileRemover(data, urldata = mixins.params()) {
        return this.request(this.api().filedeleter, data)
            .urltransform(urldata)
            .multipart()
            .exec()
            .log()
            .get();
    },
    apiFileDownloader(data, urldata = mixins.params()) {
        return this.request(this.api().fileDownloader, data)
            .urltransform(urldata)
            .multipart()
            .exec()
            .log()
            .get();
    },
    apiGetFileMetaData(urldata) {
        return this.request(this.api().getFileMetaData)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => {
                return response.data;
            })
            .get();
    },
    apiGetAllProducts(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().getAllPackages, payload)
            .exec()
            .log()
            .mapresults((response) => {
                return {
                    data: response.data[0].records,
                    total: response.data[0].pagination[0]?.totalRecords || 0,
                };
            })
            .get();
    },
    apiGetAllAccessibleProducts(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().getAllAccessiblePackages, payload)
            .exec()
            .log()
            .mapresults((response) => {
                return {
                    data: response.data[0].records,
                    total: response.data[0].pagination[0]?.totalRecords || 0,
                };
            })
            .get();
    },
    apiGetProductById(urldata = {}) {
        console.log({ apiGetProductById: urldata });

        return this.request(this.api().getPackageById)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => {
                return {
                    data: response.data,
                };
            })
            .get();
    },
    apiGetSubModules(data, urldata = {}) {
        let payload = {
            ...data,
        };
        return this.request(this.api().getSubModules, payload)
            .exec()
            .log()
            .mapresults((response) => {
                return {
                    data: response.data,
                };
            })
            .get();
    },
    apiGetCurriculumGrades(data, urldata = {}) {
        let payload = {
            ...data,
        };
        return this.request(this.api().getCurriculumGrades, payload)
            .exec()
            .log()
            .mapresults((response) => {
                return {
                    data: response.data,
                };
            })
            .get();
    },
    // 
    apiGetContentBySession(urldata = {}) {
        return this.request(this.api().getContentBySession)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => {
                return {
                    data: response.data,
                    total: response.count || 0,
                };
            })
            .get();
    },
    apiGetContentSessionById(urldata = {}) {
        return this.request(this.api().getcontentSessionById)
            .urltransform(urldata)
            .exec()
            .log()
            .get();
    },
    apiGetAssessments(urldata = {}) {
        return this.request(this.api().getAssessments)
            .urltransform(urldata)
            .exec()
            .log()
            .mapresults((response) => {
                return {
                    data: response.data,
                    total: response.data.length || 0,
                };
            })
            .get();
    },
    apiGetAssessmentById(data) {
        return this.request(this.api().getAssessmentById)
            .urltransform(data)
            .exec()
            .log()
            .mapresults((response) => {
                return {
                    data: response.data,
                };
            })
            .get();
    },
    apiAddCustomerAssessment(data) {
        return this.request(this.api().addCustomerAssessment, data)
            .exec()
            .log()
            .mapresults((response) => {
                return response.data;
            })
            .get();
    },
    apiScanQRcode(data) {
        return this.request(this.api().scanQRcode, data)
            .exec()
            .log()
            .get();
    },
}